// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dash {
  border: dashed grey 4px;
  background-color: rgba(255, 255, 255, 0.8); }

.drag-container {
  height: 100%; }

.fit-to-parent {
  display: block;
  height: 100%;
  width: 100%; }

.toolbar-container {
  margin-bottom: 16px;
  display: flex; }
  .toolbar-container .left-toolbar {
    flex-grow: 1;
    flex-shrink: 1000;
    margin-right: 8px;
    min-width: 50px; }
  .toolbar-container .search-container {
    display: flex;
    min-width: 50px;
    justify-content: flex-end; }
  .toolbar-container .right-toolbar {
    flex-grow: 1000;
    min-width: 50px;
    display: flex;
    justify-content: flex-end; }

.center-content {
  display: flex;
  justify-content: center;
  align-items: center; }

.bwc-toast-wrapper {
  width: 100%; }
  .bwc-toast-wrapper > .bwc-toast-all.bwc-toast-entered > div {
    display: flex; }

.ReactTable .rt-thead {
  -ms-user-select: auto; }

.ReactTable .rt-thead .rt-th:hover .th-sort-arrow {
  display: inherit;
  fill: #9ba5ae; }

.ReactTable .normal-font-weight-header span {
  font-weight: normal; }

.ReactTable .normal-font-weight-header.name-header svg.th-sort-arrow {
  transform: rotate(180deg) !important; }

.bwc-btn-with-dd .bwc-buttons-blue {
  padding-left: 15px;
  padding-right: 15px; }
  .bwc-btn-with-dd .bwc-buttons-blue.new-button {
    box-sizing: border-box;
    white-space: nowrap; }
    .bwc-btn-with-dd .bwc-buttons-blue.new-button.small-new-button .button-icon {
      margin: 0px; }

.paginator-icon-disabled {
  cursor: default; }

.bwc-alerts-warning {
  margin-bottom: 4px; }

div > .set-folder-access-modal {
  height: 50%; }

div > .set-folder-access-modal {
  height: 50%; }

div > .set-folder-access-modal .set-folder-access-data .rt-noData {
  padding: 0px; }

div > .set-folder-access-modal .set-folder-access-data .rt-table {
  overflow-Y: auto; }

.bwc-modal {
  max-height: 75%; }

.tooltip-content {
  display: inline; }
  .tooltip-content .tooltip {
    display: inline; }

.bwc-inputs-labeled-input .input.with-icon,
.bwc-inputs-labeled-input.collapsed .input.with-icon {
  height: 38px !important; }

input::-ms-clear {
  display: none; }

.rt-tr-group {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none; }

.ideas > .bwc-buttons-blue {
  width: 28px !important;
  height: 22px !important;
  margin-left: 10px;
  margin-top: 0px; }

.bwc-tables-breadcrumbs {
  position: relative;
  background-color: #fff;
  box-shadow: none;
  margin: 0; }

.not-resizable textarea {
  width: 100% !important;
  height: 20% !important;
  resize: none;
  overflow: auto; }

#connect-footer {
  min-height: 40px; }

#HFNavBarContainer {
  height: 53px; }
`, "",{"version":3,"sources":["webpack://./src/components/styles.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,0CAA0C,EAAE;;AAE9C;EACE,YAAY,EAAE;;AAEhB;EACE,cAAc;EACd,YAAY;EACZ,WAAW,EAAE;;AAEf;EACE,mBAAmB;EACnB,aAAa,EAAE;EACf;IACE,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,eAAe,EAAE;EACnB;IACE,aAAa;IACb,eAAe;IACf,yBAAyB,EAAE;EAC7B;IACE,eAAe;IACf,eAAe;IACf,aAAa;IACb,yBAAyB,EAAE;;AAE/B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAE;;AAEvB;EACE,WAAW,EAAE;EACb;IACE,aAAa,EAAE;;AAEnB;EACE,qBAAqB,EAAE;;AAEzB;EACE,gBAAgB;EAChB,aAAa,EAAE;;AAEjB;EACE,mBAAmB,EAAE;;AAEvB;EACE,oCAAoC,EAAE;;AAExC;EACE,kBAAkB;EAClB,mBAAmB,EAAE;EACrB;IACE,sBAAsB;IACtB,mBAAmB,EAAE;IACrB;MACE,WAAW,EAAE;;AAEnB;EACE,eAAe,EAAE;;AAEnB;EACE,kBAAkB,EAAE;;AAEtB;EACE,WAAW,EAAE;;AAEf;EACE,WAAW,EAAE;;AAEf;EACE,YAAY,EAAE;;AAEhB;EACE,gBAAgB,EAAE;;AAEpB;EACE,eAAe,EAAE;;AAEnB;EACE,eAAe,EAAE;EACjB;IACE,eAAe,EAAE;;AAErB;;EAEE,uBAAuB,EAAE;;AAE3B;EACE,aAAa,EAAE;;AAEjB;EACE,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;EAC3B,iBAAiB,EAAE;;AAErB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,SAAS,EAAE;;AAEb;EACE,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,cAAc,EAAE;;AAElB;EACE,gBAAgB,EAAE;;AAEpB;EACE,YAAY,EAAE","sourcesContent":[".dash {\n  border: dashed grey 4px;\n  background-color: rgba(255, 255, 255, 0.8); }\n\n.drag-container {\n  height: 100%; }\n\n.fit-to-parent {\n  display: block;\n  height: 100%;\n  width: 100%; }\n\n.toolbar-container {\n  margin-bottom: 16px;\n  display: flex; }\n  .toolbar-container .left-toolbar {\n    flex-grow: 1;\n    flex-shrink: 1000;\n    margin-right: 8px;\n    min-width: 50px; }\n  .toolbar-container .search-container {\n    display: flex;\n    min-width: 50px;\n    justify-content: flex-end; }\n  .toolbar-container .right-toolbar {\n    flex-grow: 1000;\n    min-width: 50px;\n    display: flex;\n    justify-content: flex-end; }\n\n.center-content {\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n\n.bwc-toast-wrapper {\n  width: 100%; }\n  .bwc-toast-wrapper > .bwc-toast-all.bwc-toast-entered > div {\n    display: flex; }\n\n.ReactTable .rt-thead {\n  -ms-user-select: auto; }\n\n.ReactTable .rt-thead .rt-th:hover .th-sort-arrow {\n  display: inherit;\n  fill: #9ba5ae; }\n\n.ReactTable .normal-font-weight-header span {\n  font-weight: normal; }\n\n.ReactTable .normal-font-weight-header.name-header svg.th-sort-arrow {\n  transform: rotate(180deg) !important; }\n\n.bwc-btn-with-dd .bwc-buttons-blue {\n  padding-left: 15px;\n  padding-right: 15px; }\n  .bwc-btn-with-dd .bwc-buttons-blue.new-button {\n    box-sizing: border-box;\n    white-space: nowrap; }\n    .bwc-btn-with-dd .bwc-buttons-blue.new-button.small-new-button .button-icon {\n      margin: 0px; }\n\n.paginator-icon-disabled {\n  cursor: default; }\n\n.bwc-alerts-warning {\n  margin-bottom: 4px; }\n\ndiv > .set-folder-access-modal {\n  height: 50%; }\n\ndiv > .set-folder-access-modal {\n  height: 50%; }\n\ndiv > .set-folder-access-modal .set-folder-access-data .rt-noData {\n  padding: 0px; }\n\ndiv > .set-folder-access-modal .set-folder-access-data .rt-table {\n  overflow-Y: auto; }\n\n.bwc-modal {\n  max-height: 75%; }\n\n.tooltip-content {\n  display: inline; }\n  .tooltip-content .tooltip {\n    display: inline; }\n\n.bwc-inputs-labeled-input .input.with-icon,\n.bwc-inputs-labeled-input.collapsed .input.with-icon {\n  height: 38px !important; }\n\ninput::-ms-clear {\n  display: none; }\n\n.rt-tr-group {\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Safari */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Old versions of Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none; }\n\n.ideas > .bwc-buttons-blue {\n  width: 28px !important;\n  height: 22px !important;\n  margin-left: 10px;\n  margin-top: 0px; }\n\n.bwc-tables-breadcrumbs {\n  position: relative;\n  background-color: #fff;\n  box-shadow: none;\n  margin: 0; }\n\n.not-resizable textarea {\n  width: 100% !important;\n  height: 20% !important;\n  resize: none;\n  overflow: auto; }\n\n#connect-footer {\n  min-height: 40px; }\n\n#HFNavBarContainer {\n  height: 53px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
